module.exports = __webpack_public_path__ + "static/media/preview_youtube.2da6882e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/GymTvPreviews/preview_youtube.png
// module id = 1087
// module chunks = 2